import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { formatError } from "@/lib/auth";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const nav = useNavigate();
  const submit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Password reset. Sign in.");
      nav("/login");
    } catch (err) { toast.error(formatError(err)); }
  };
  return (
    <div className="min-h-screen grid place-items-center p-4">
      <Card className="w-full max-w-md p-8">
        <h1 className="font-serif text-2xl mb-4">Set a new password</h1>
        <form onSubmit={submit} className="space-y-4">
          <div><Label>New password</Label><Input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={e=>setPassword(e.target.value)} /></div>
          <Button data-testid="reset-submit-btn" type="submit" className="w-full">Reset password</Button>
        </form>
        <Link to="/login" className="text-sm mt-4 block text-muted-foreground">Back to sign in</Link>
      </Card>
    </div>
  );
}
